import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import NavigationButton from './navigationButton.component';

const Navigation = ({ activeElement, onChange, definitions, disabled }) => (
  <div className="nav-container">
    <ul className="navigation nav nav-pills">
      {definitions.map((element, index) => (
        <li className="nav-item" key={index}>
          <NavigationButton
            className={classnames({ 'a-tag-e49': activeElement !== element.type })}
            element={element}
            onChange={onChange}
            disabled={disabled}
          />
        </li>
      ))}
    </ul>
  </div>
);

Navigation.propTypes = {
  activeElement: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  definitions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  })).isRequired,
  disabled: PropTypes.bool,
};

export default Navigation;
